export const MODAL_OPEN = 'MODAL_OPEN';
export const MODAL_OPEN_AND_CLOSE_LAST = 'MODAL_OPEN_AND_CLOSE_LAST';
export const MODAL_CLOSE_ALL = 'MODAL_CLOSE_ALL';
export const MODAL_CLOSE_LAST = 'MODAL_CLOSE_LAST';
export const MODAL_CLOSE = 'MODAL_CLOSE';
